import { useAuthStore } from '@caradasstore/AuthStore'
import { useCenterStore } from '@caradasstore/CenterStore'
import { useUserStore } from '@caradasstore/UserStore'
import { useOrganisationStore } from '@caradasstore/OrganisationStore'
import { useAvailabilityStore } from '@caradasstore/AvailabilityStore'
import useAdasIntelligenceStore from '@caradasstore/AdasIntelligenceStore'
import useEntitlementStore from '@caradasstore/EntitlementStore'
import { getUserList } from '../../api/api'
import { Logger } from '../../logger'
import { clearCachedCalibrationCenters } from '../../utils/calibrationCenterCache'
import { resetCenterListBootstrap } from '../../utils/centerListBootstrap'

/**
 * Signs a just-created owner in with the session the sign-up API returned — the same payload
 * /authenticate returns, applied exactly as AuthForm does: wipe any previous account's
 * per-account state, set the active center, then log in. Used by the email-confirmation page
 * (account created → choose a package) and by the legacy return from a sign-up Checkout.
 */
export const applySignUpSession = async (auth, email) => {
  if (!auth?.token || auth?.ccid == null) {
    throw new Error('Sign-in details were not returned.')
  }
  useCenterStore.getState().reset?.()
  useUserStore.getState().reset?.()
  useOrganisationStore.getState().reset?.()
  useAvailabilityStore.getState().reset?.()
  useAdasIntelligenceStore.getState().reset?.()
  useEntitlementStore.getState().reset?.()
  clearCachedCalibrationCenters()
  // Also forget that the location list was loaded — the tab may still hold another account's,
  // and the switcher would otherwise show "Select center" for the new owner.
  resetCenterListBootstrap()
  const center = useCenterStore.getState()
  center.setCcId(auth.ccid)
  center.setAccessibleCcIds([...(auth.ccidOwned || []), ...(auth.ccidManaged || []), ...(auth.ccidTech || []), auth.ccid])
  center.setIsCenterAdmin(false)
  useAuthStore.getState().login(auth.token, auth.refreshToken)
  try {
    const users = await getUserList({ ccid: auth.ccid })
    const me = users?.data?.find((u) => u.email?.toLowerCase() === email?.toLowerCase())
    if (me) useUserStore.getState().setCurrentUser(me)
  } catch (userError) {
    Logger.error({ message: userError?.message, payload: { path: 'applySignUpSession/getUserList', ccid: auth.ccid } })
  }
}
